/*
役所地番地図（TRUSTART 地番図データ）レイヤーの描画色
タイル描画（TrustartChibanTileLayer / TrustartChibanCoverageStrokeOverlay）と凡例（Legend）の
両方で同じ色を使うので、ここにまとめておいて変更が片側にしか反映されない事故を防ぐ
*/

import { toRgba } from "@/features/map/utils/toRgba";

// 筆界（地番ポリゴン）の枠線色。
// GEOSPACE=赤・ゼンリン地番文字=青・下地マップ=緑 と被らないよう識別性を確保する。
export const TRUSTART_CHIBAN_PARCEL_STROKE_COLOR = "#ff005d";

// 対応エリアの塗り・枠線。canvas / SVG には不透明で描き、透過はレイヤーコンテナや
// ペインの CSS opacity で掛ける（ズーム遷移中の重なりで濃くならない）
export const TRUSTART_CHIBAN_COVERAGE_FILL_COLOR = "#e55288";
export const TRUSTART_CHIBAN_COVERAGE_FILL_OPACITY = 0.5;
export const TRUSTART_CHIBAN_COVERAGE_STROKE_COLOR = "#D81B60";
export const TRUSTART_CHIBAN_COVERAGE_STROKE_OPACITY = 0.8;

/** 凡例用の対応エリア色（地図上の見た目＝塗り色×不透明度と一致させる） */
export const TRUSTART_CHIBAN_COVERAGE_LEGEND_COLOR = toRgba(
  TRUSTART_CHIBAN_COVERAGE_FILL_COLOR,
  TRUSTART_CHIBAN_COVERAGE_FILL_OPACITY
);
